"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var cool_storage_base_1 = require("./cool-storage-base");
var cool_server_storage_1 = require("./cool-server-storage");
var CoolLocalStorage = (function (_super) {
    __extends(CoolLocalStorage, _super);
    function CoolLocalStorage(platformId) {
        var _this = this;
        if (common_1.isPlatformBrowser(platformId)) {
            _this = _super.call(this, window.localStorage, 'LocalStorage') || this;
        }
        else {
            _this = _super.call(this, new cool_server_storage_1.CoolServerStorage(), 'LocalStorage') || this;
        }
        return _this;
    }
    return CoolLocalStorage;
}(cool_storage_base_1.CoolStorageBase));
CoolLocalStorage.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
CoolLocalStorage.ctorParameters = function () { return [
    { type: Object, decorators: [{ type: core_1.Inject, args: [core_1.PLATFORM_ID,] },] },
]; };
exports.CoolLocalStorage = CoolLocalStorage;
//# sourceMappingURL=cool-local-storage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular2-cool-storage/src/cool-local-storage.js
// module id = 566
// module chunks = 3